// components/auth/github-signin-button.tsx
'use client';

import { signIn } from 'next-auth/react';
import { Button } from '@/components/ui/button';
import { Github } from 'lucide-react';

export function GithubSignInButton() {
  const handleGithubSignIn = async () => {
    try {
      await signIn('github', {
        callbackUrl: '/dashboard', // 登录成功后重定向的页面
      });
    } catch (error) {
      console.error('GitHub sign in error:', error);
    }
  };

  return (
    <Button
      variant="outline"
      className="w-full flex items-center justify-center gap-2"
      onClick={handleGithubSignIn}
    >
      <Github className="h-4 w-4" />
      使用 GitHub 登录
    </Button>
  );
}

